export class Regulatory {
  hasPoliticalFriends: boolean;

  regulatoryControl: RegulatoryDetail = new RegulatoryDetail();
  regulatoryAffiliation: RegulatoryDetail = new RegulatoryDetail();
  affiliationDetails: AffiliationDetails = new AffiliationDetails();

  employeePubTrade: PubTradeDetails;
  controlPubTrade: PubTradeDetails;
}
export class RegulatoryDetail {
  code: string;
  detail: string;
  status: boolean;
}

export class AffiliationDetails {
  affiliationRelationship: string;
  personName: string;
  company: string;
  mailingPostalCode: string;
  mailingCountry: string;
  mailingState: string;
  mailingCity: string;
  address1: string;
  address2: string;
  companyPhone: string;
  companyEmail: string;
}

export class PubTradeDetails {
  status: boolean;
  detail: string;
}
